/**
 * Per-hotel fixed "sfeerfoto" (Dennis 2026-10-04, on the ING Düsseldorf page:
 * "Dit wil je natuurlijk niet als eerste deelnemende partnerhotel zien, hè?
 * Wat een lelijk gebouw, zeg!").
 *
 * Maps hotel_id → https url of the photo that represents the hotel in the
 * "Sfeerbeeld van de hotels" carousel fallback and at the front of the hotel
 * popup, instead of the supplier's first photo (mostly a bare facade).
 *
 * Same static-import pattern as deal-sfeerbeeld-lead. Returns null when no
 * valid https url is set, which keeps every other hotel byte-identical.
 */
import data from "../../../content/hotel-sfeerbeeld.json";

export function sfeerbeeldForHotel(hotelId) {
  if (hotelId == null || hotelId === "") return null;
  if (!Object.prototype.hasOwnProperty.call(data, String(hotelId))) return null;
  const value = data[String(hotelId)];
  if (typeof value !== "string") return null;
  const url = value.trim();
  return url.length > 0 && url.startsWith("https://") ? url : null;
}
